/*
 * @Author: your name
 * @Date: 2020-10-22 14:02:44
 * @LastEditTime: 2021-11-25 01:58:40
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: /ksh-factory-vue/src/main.js
 */
import Vue from 'vue';
import './utils/elm-import'
import './styles/element-variables.scss'
import App from './App.vue';
import router from './router';
import store from './store';
import Moment from 'moment'
import { Message } from 'element-ui';
const $message = options => {
  return Message({
    ...options,
    offset: 60
  });
};

// 自动注册全局组件


//重写一遍success的方法,将offset写入options
;['success', 'warning', 'info', 'error'].forEach(type => {
  $message[type] = options => {
    if (typeof options === 'string') {
      options = {
        message: options,
        duration: 5000
      };
    }
    options.type = type;
    return Message(options);
  };
});


//将$message挂载到this上
Vue.prototype.$message = $message;

Vue.prototype.$moment = Moment
Vue.config.productionTip = false;
// Vue.use(ElementUI);
export default new Vue({
  router,
  store,
  render: (h) => h(App),
}).$mount('#app');
